import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { OverlapIconComponent } from '../overlap-icon'
import { SendContactEditDialogModule } from '../send-contact-edit-dialog'
import { AuthorizationStatusIconComponent } from './components/authorization-status-icon.component'
import { ConfirmationStatusIconComponent } from './components/confirmation-status-icon.component'
import { EligibilityStatusIconComponent } from './components/eligibility-status-icon.component'
import { IntakeCodeDialogComponent } from './components/intake-code-dialog.component'
import { IntakeStatusIconComponent } from './components/intake-status-icon.component'
import { PaymentStatusIconComponent } from './components/payment-status-icon.component'
import { ReferralStatusIconComponent } from './components/referral-status-icon.component'
import { WaitListStatusIconComponent } from './components/wait-list-status-icon'
import { WorkListStatusComponent } from './components/work-list-status'

const components = [
  AuthorizationStatusIconComponent,
  ConfirmationStatusIconComponent,
  EligibilityStatusIconComponent,
  IntakeStatusIconComponent,
  PaymentStatusIconComponent,
  ReferralStatusIconComponent,
  WaitListStatusIconComponent,
  WorkListStatusComponent,
]

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    OverlapIconComponent,
    PipesModule,
    SendContactEditDialogModule,
    RouterModule,
    TranslateModule,
  ],
  exports: [...components],
  declarations: [IntakeCodeDialogComponent, ...components],
})
export class StatusIconsModule {}
